import { html } from 'lit-html';
import { ReviewAreaAction } from '../../../actions/review/review_area_action';
import { FeedBackModel } from '../../../models/review/review_js_env';

const BeforeFeedback = (model: FeedBackModel) => {
  if(!model.viewerVoted){
    return html`
      <div class="m-useful_reference js-feedback">
        <p class="a-text">このレビューは参考になりましたか？</p>
        <div class="m-useful_referenceButton">
          <button
            class="m-btn -base"
            type="button"
            @click=${() => ReviewAreaAction.sendFeedbackUsefulness(model, true)}
          >
            <span class="m-btn_inner">
              <span class="m-btn_text">はい</span>
            </span>
          </button>
          <button
            class="m-btn -base"
            type="button"
            @click=${() => ReviewAreaAction.sendFeedbackUsefulness(model, false)}
          >
            <span class="m-btn_inner">
              <span class="m-btn_text">いいえ</span>
            </span>
          </button>
        </div>
      </div>
    `;
  } else {
    return html``;
  }
}

const AfterFeedback = () => html`
  <div class="m-useful_reference js-feedback is-submitted">
    <div class="a-heading -typep">
      <p class="a-heading_text">
        <b>フィードバックありがとうございます</b>
      </p>
    </div>
  </div>
`;

const FeedbackAreaContent = (model: FeedBackModel) => {
  const hasClick = !!model.hasClick;

  return html`
    <div class="m-useful_evaluation">
      <p class="a-text">
        <span class="a-span u-text-middledarkorange u-text-bold">${model.referenceTotal}</span>
        人中
        <span class="a-span u-text-middledarkorange u-text-bold">${model.referencePersons}</span>
        人の方が「参考になった!」と言っています。
      </p>
    </div>
    ${hasClick ? AfterFeedback() : BeforeFeedback(model)}
  `;
};

const EmptyArea = html``;

export const FeedbackArea = (model: FeedBackModel) => {
  return model.feedbackUrl ? FeedbackAreaContent(model) : EmptyArea;
};
